import { render, staticRenderFns } from "./EnthalpyEntropyOfBoraxSIM.vue?vue&type=template&id=1875a0b9&"
import script from "./EnthalpyEntropyOfBoraxSIM.vue?vue&type=script&lang=js&"
export * from "./EnthalpyEntropyOfBoraxSIM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports